import type { environment } from '@trello/config';

const productionTemplateList = {
  en: {
    business: [
      '5b1a7ddba4b022243dce528e',
      '569eb2049b4e042cef68e2d0',
      '55107c70c088e6dc80bf2553',
      '5c3e2f948af0c952c092ce40',
    ],
    marketing: [
      '57e1548d041d8599c91361f5',
      '5810c69adef713d52241ca9e',
      '5c3e2fdb0fa92e43b849d838',
      '5810cf5086de0afa22d3dbea',
    ],
    education: [
      '5dae5379616fd0851a223f73',
      '554cfe296e5c05c46f99ff35',
      '566f021b04239fa9071235e3',
      '563d24cb4b3cf618865c1e30',
    ],
    'operations-hr': [
      '5da0b4c975eaf61076dcd26f',
      '5db701d97db0e076672aa580',
      '5c3e2fdb0fa92e43b849d838',
      '5d88d51b18495e7d08448d22',
    ],
    operations: [
      '5c3e2f948af0c952c092ce40',
      '5c3e2fdb0fa92e43b849d838',
      '5d7a7e66becb3d3a8530b7ed',
      '5d76dc01d389785544acc991',
    ],
    engineering: [
      '5e20e06c460b391727ce7a2b',
      '57a8923bea585928f4caf750',
      '57a890c6504676888e1dd736',
      '58138a00e9178943a2fc3f19',
    ],
    popular: [
      '5c3e2fdb0fa92e43b849d838',
      '5e20e06c460b391727ce7a2b',
      '5e110382bbcd021dda283413',
      '5a6a0d359ba9a3ff45dfe5a8',
    ],
    'sales-crm': [
      '5d7fce05db47576609123445',
      '5da0c23332c6eb0562f8e587',
      '551d99a20c5e9fd268d0ccda',
      '5c0e4c8c4f599933363bc3b2',
    ],
    design: [
      '5da499e11c585209f44a1c20',
      '5570bac5d9ebdefcf6a1080b',
      '5cffc8bc4899412c91f865e1',
      '5ec1dc46ee966724ac07af76',
    ],
  },
  fr: {
    business: [
      '5994be8ce20c9b37589141c2',
      '5ecda0586d9eb31d6c867837',
      '5994bf29195fa87fb9f27709',
      '5a7b8c534f94339b7a62bbc8',
    ],
    marketing: [
      '5aaafd432693e874ec11495c',
      '5b67b812c054271ec0e8d09b',
      '55bab67bd152ec0cec7ae5e9',
      '5c4efa1d25a9692173830e7f',
    ],
    education: [
      '55ae47cb609554b6290d58c3',
      '5ec98d97f98409568dd89dff',
      '56718ae272d738724d76a6da',
      '5c4efa1d25a9692173830e7f',
    ],
    'operations-hr': [
      '5ecd9f904e913704e0e6bac9',
      '5b9f88e34657695509bfdc7d',
      '5994bf29195fa87fb9f27709',
      '5c4efa1d25a9692173830e7f',
    ],
    operations: [
      '5c4efa0e586cd43c34b60ec4',
      '5994be8ce20c9b37589141c2',
      '5a7b8c534f94339b7a62bbc8',
      '5c4efa1d25a9692173830e7f',
    ],
    engineering: [
      '5e6005043fbdb55d9781821e',
      '591ca6422428d5f5b2794aee',
      '5a185b8fad875aa32fca1012',
      '5b5ff9e5e62c8a0dea233ae9',
    ],
    popular: [
      '5c4efa1d25a9692173830e7f',
      '5e6005043fbdb55d9781821e',
      '5c4efa2bdcbd2f60958b4b8a',
    ],
    'sales-crm': [
      '5acde219f8ae904ee26f8e99',
      '5abe23b9e1f17a34073ad98c',
      '5abe1d1835f29e2c725512df',
      '5c4efa1d25a9692173830e7f',
    ],
    design: [
      '5ba2ed3c8cfd7e58a7d70271',
      '5ba2f82a4b57cd48bbdabc5a',
      '5ba3db99133f506b2417f604',
      '5c4efa1d25a9692173830e7f',
    ],
  },
  'pt-BR': {
    business: [
      '559bf63a3e9f6b3b0486ffbf',
      '5c4ef6244089b88c06bd9f2c',
      '5ecd9ee6ece9d5654f16374c',
      '576156c1f4859f1017f8bd17',
    ],
    marketing: [
      '572a431da65e2702e1b056e1',
      '5b0927c4ecfa3ca7549af3b7',
      '5b2103bf703f6174a01bbebd',
      '5c4ef615717f047b64dcda5f',
    ],
    education: [
      '5ecbbf6cfb70b949486c7db5',
      '56718b84c87748414dca0fab',
      '54fdf4f31218c06c1144c954',
      '5c4ef615717f047b64dcda5f',
    ],
    'operations-hr': [
      '5ecda5df41df0d610a53d017',
      '58417067db670e3271a80c9f',
      '57e30f7e36576bd48397a341',
      '5c4ef615717f047b64dcda5f',
    ],
    operations: [
      '58416df3b215d73f7796c9a9',
      '559bf63a3e9f6b3b0486ffbf',
      '56bddb538f03a13bd941f985',
      '5c4ef615717f047b64dcda5f',
    ],
    engineering: [
      '5e6005486e20e75989cf97e4',
      '58408282d0ddd4b7474a7e22',
      '5b2be96ef5135c52798cc843',
      '58408236e183023355927dbd',
    ],
    popular: [
      '5c4ef615717f047b64dcda5f',
      '5e6005486e20e75989cf97e4',
      '5c4ef6244089b88c06bd9f2c',
      '5b6e7929895ea23dbd6329b5',
    ],
    'sales-crm': [
      '5844069d015ec976063d80bd',
      '569d31961c5e671bf751ca03',
      '5741202c57ac2e0c1d4d880b',
      '5c4ef615717f047b64dcda5f',
    ],
    design: [
      '5b6e8c8406ec86639525566f',
      '5b6e7f32d034998d4c3d9893',
      '5975e93259d1fbb224d0541d',
      '5c4ef615717f047b64dcda5f',
    ],
  },
};

const stagingTemplateList = {
  en: {
    business: [
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2ce2bc0cfe714f98e30b',
      '5f245abe18d10073b082f51b',
      '5d9e2c9dbc0cfe714f98e1f8',
    ],
    marketing: [
      '5ceee0a9806f6241c81eb2d3',
      '5f245abe18d10073b082f51b',
      '5d9e2ce2bc0cfe714f98e30b',
      '5d9e2c9dbc0cfe714f98e1f8',
    ],
    education: [
      '5f245abe18d10073b082f51b',
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2ce2bc0cfe714f98e30b',
      '5d9e2c9dbc0cfe714f98e1f8',
    ],
    'operations-hr': [
      '5d9e268bfe3f36439932c2e4',
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2c9dbc0cfe714f98e1f8',
      '5f245abe18d10073b082f51b',
    ],
    operations: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2ce2bc0cfe714f98e30b',
      '5f245abe18d10073b082f51b',
    ],
    engineering: [
      '5ceee0a9806f6241c81eb2d3',
      '5f245abe18d10073b082f51b',
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2ce2bc0cfe714f98e30b',
    ],
    popular: [
      '5f245abe18d10073b082f51b',
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2ce2bc0cfe714f98e30b',
      '5d9e2c9dbc0cfe714f98e1f8',
    ],
    'sales-crm': [
      '5d9e2ce2bc0cfe714f98e30b',
      '5f245abe18d10073b082f51b',
      '5d9e2c9dbc0cfe714f98e1f8',
      '5ceee0a9806f6241c81eb2d3',
    ],
    design: [
      '5ceee0a9806f6241c81eb2d3',
      '5d9e2ce2bc0cfe714f98e30b',
      '5f245abe18d10073b082f51b',
      '5d9e2c9dbc0cfe714f98e1f8',
    ],
  },
  fr: {
    business: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    marketing: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    education: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    'operations-hr': ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    operations: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    engineering: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    popular: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    'sales-crm': ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
    design: ['5d9e266b3bdb4d437cf6ac24', '5d9e328dda98a04647333364'],
  },
  'pt-BR': {
    business: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e268bfe3f36439932c2e4',
    ],
    marketing: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    education: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    'operations-hr': [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    operations: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    engineering: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    popular: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    'sales-crm': [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
    design: [
      '5d9e2c9dbc0cfe714f98e1f8',
      '5d9e2cb81920cb4605e7ca1b',
      '5d9e2e455c0a1b45bd2e902e',
      '5d9e2df3988ae73d6198efc3',
    ],
  },
};

export const getBoardPickerTemplates = (env: typeof environment) => {
  if (env === 'prod') {
    return productionTemplateList;
  } else if (env === 'staging') {
    return stagingTemplateList;
  }
  return {};
};
